<mat-card
    appearance="outlined"
    class="program-card"
    (click)="programCardClick()"
    [ngClass]="{ 'selected-program-card': toggle }"
    id="{{ 'program-' + program.programId }}"
>
    <img
        class="program-icon"
        src="{{ program.logoPath }}"
        [alt]="program.name"
        [name]="program.name"
    />
    <mat-card-title class="program-name">{{ program.name }}</mat-card-title>
    <mat-card-content class="program-description">
        <p>{{ program.description }}</p>
    </mat-card-content>
</mat-card>
